import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0119',
    ecrans: ['00-2']
});
